import * as ActionTypes from 'actions';

const initialState = {
  isVisible: false,
};

export default function(state = initialState, action = {}) {
  const { type } = action;

  switch (type) {
  case ActionTypes.MODAL_VISIBLE:
    return { ...state, isVisible: true };

  case ActionTypes.MODAL_HIDDEN:
    return { ...state, isVisible: false };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/modal.js